import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  select,
  takeLatest,
  takeEvery,
  take
} from 'redux-saga/effects'
import { normalize } from 'normalizr'

import { Artwork } from 'api'
import { humanizeFilename } from 'lib/formatter'
import { getArtworkUploads, getIsFetchingArtworks } from 'redux/reducers'
import * as actions from 'redux/actions'
import * as actionTypes from 'redux/actionTypes'
import * as routes from 'routes'
import * as schema from 'redux/actions/schema'

export function * receiveArtworkFiles (action) {
  const files = action.files

  for (let i = 0; i < files.length; i++) {
    const file = files[i]
    const name = humanizeFilename(file.name)
    yield put(actions.createArtwork({ name }, file))
    yield take([
      actionTypes.CREATING_ARTWORK_SUCCEEDED,
      actionTypes.CREATING_ARTWORK_FAILED
    ])
  }

  yield put(actions.artworkFilesProcessed())

  const history = action.routerHistory
  yield call(history.push, routes.upload())
}

export function * initProcessingArtworkUploads (action) {
  const uploads = yield select(getArtworkUploads)

  for (let i = 0; i < uploads.length; i++) {
    const upload = uploads[i]
    const task = yield fork(
      uploadArtwork, upload.id, upload.file, action.dispatch)
    const resultAction = yield take([
      actionTypes.UPLOADING_ARTWORK_SUCCEEDED,
      actionTypes.UPLOADING_ARTWORK_FAILED,
      actionTypes.ARTWORK_UPLOADS_STOP_PROCESSING
    ])
    if (resultAction.type === actionTypes.ARTWORK_UPLOADS_STOP_PROCESSING) {
      yield cancel(task)
      break
    }
  }
}

export function * stopProcessingArtworkUploads (action) {
  yield put(actions.artworkUploadsEmpty())
}

export function * uploadArtwork (id, file, dispatch) {
  try {
    yield put({ type: actionTypes.FETCHING })
    yield put({ type: actionTypes.UPLOADING_ARTWORK, id })

    const result = yield call(Artwork.uploadImage, id, file,
      (progress) => {
        dispatch({
          type: actionTypes.UPLOADING_ARTWORK_PROGRESS,
          id,
          progress
        })
      }
    )

    const artwork = result.response

    yield put({ type: actionTypes.FETCHING_ENDED })

    if (result.status === 200) {
      yield put({
        type: actionTypes.UPLOADING_ARTWORK_SUCCEEDED,
        id: artwork.id,
        payload: normalize(artwork, schema.artwork)
      })
    } else {
      yield put({ type: actionTypes.UPLOADING_ARTWORK_FAILED, id })
    }
  } finally {
    if (yield cancelled()) {
      yield put({ type: actionTypes.FETCHING_ENDED })
      yield put({ type: actionTypes.UPLOADING_ARTWORK_FAILED, id })
    }
  }
}

export function * updateArtwork (action) {
  let isFetchingArtworks = yield select(getIsFetchingArtworks)

  if (isFetchingArtworks) {
    yield take([
      actionTypes.LOADING_ARTWORKS_SUCCEEDED,
      actionTypes.LOADING_ARTWORKS_FAILED
    ])
  }

  yield put({ ...action, type: actionTypes.LOADING_ARTWORKS_SUCCEEDED })
}

function * watchArtworkFilesReceive () {
  yield takeEvery(actionTypes.ARTWORK_FILES_RECEIVE, receiveArtworkFiles)
}

function * watchArtworkUploadsInitProcessing () {
  yield takeLatest(
    actionTypes.ARTWORK_UPLOADS_INIT_PROCESSING, initProcessingArtworkUploads)
}

function * watchArtworkUploadsStopProcessing () {
  yield takeLatest(
    actionTypes.ARTWORK_UPLOADS_STOP_PROCESSING, stopProcessingArtworkUploads)
}

function * watchUploadingArtworkSucceeded () {
  yield takeEvery(
    actionTypes.UPLOADING_ARTWORK_SUCCEEDED, updateArtwork)
}

export default function * rootSaga () {
  yield all([
    watchArtworkFilesReceive(),
    watchArtworkUploadsInitProcessing(),
    watchArtworkUploadsStopProcessing(),
    watchUploadingArtworkSucceeded()
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js